import * as R from 'ramda';
import useMoney from '../../../hooks/useMoney';
import { UseMoneyRendererV3Props } from '../MoneyRendererV3/moneyRendererV3.types';
import { formatWithSign } from './utils/moneyRenderer.utils';

const useMoneyRendererV3 = ({ promotionValue, value, useSign }: UseMoneyRendererV3Props) => {
  const { formatMoney, getCurrencySymbol, decimalSeparator } = useMoney();

  const hasPromotion = !R.isNil(promotionValue) && Number(promotionValue) < Number(value);

  const valueParts = formatMoney(value).split(decimalSeparator);
  const valueRealPart = useSign ? formatWithSign(value, formatMoney) : valueParts[0];

  const promotionValueParts = hasPromotion
    ? formatMoney(promotionValue).split(decimalSeparator)
    : '';
  const isZeroValue = value === 0;
  const isZeroPromotionValue = promotionValue === 0;

  const valueConfig = {
    real: valueRealPart,
    cents: !isZeroValue && (valueParts[1] || '').padEnd(2, '0'),
  };

  const promotionConfig = {
    real: promotionValueParts[0],
    cents: !isZeroPromotionValue && (promotionValueParts[1] || '').padEnd(2, '0'),
  };

  return {
    currencySymbol: getCurrencySymbol(),
    hasPromotion,
    valueConfig,
    promotionConfig,
  };
};

export default useMoneyRendererV3;
